export default __webpack_public_path__ + "images/register-beneficiary-ico.svg";